import * as React from 'react'

import SEO from '../components/common/SEO'
import TopContent from '../components/top/TopContent'

export type IndexPageProps = {}

const IndexPage: React.FC<IndexPageProps> = () => {
  const seo = {}
  return (
    <>
      <SEO {...seo} />
      <TopContent />
    </>
  )
}

export default IndexPage
